import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { SalesRedirectionButtonInterface } from 'common/types/entities/button-interface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createSalesRedirectionButton(
  parentId: string,
  masterBlockId?: MasterBlockId,
): SalesRedirectionButtonInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.SalesRedirectionButton,
    parentId: parentId,
    masterBlockId: masterBlockId,
    text: '',
    textFontSize: 20,
    subTextFontSize: 14,
    lineHeight: 23,
    textColor: 'rgba(255, 255, 255, 1)',
    subTextColor: 'rgba(255,255,255,0.8)',
    background: 'rgba(1, 116, 199, 1)',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    mobileBoxShadow: 'none',
    width: 'auto',
    mobileWidth: '100%',
    alignSelf: 'center',
    border: {
      width: 1,
      style: BorderStyleEnum.none,
      radius: {
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
        borderBottomLeftRadius: 5,
      },
    },
    margin: {
      marginTop: 25,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    padding: {
      paddingTop: 9,
      paddingRight: 25,
      paddingBottom: 9,
      paddingLeft: 25,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.SalesRedirectionButton),
    childIds: [],
  }
}
